import React from "react";
import logo from "../../images/logo.png";

class Header extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};

    }

    render() {
        return (
            <div>
            <header className="bg-info py-4 mb-4">
                <div className="container h-100">
                    <div className="row h-100 align-items-center">
                        <div className="col-lg-8">
                            <h1 className="text-white mt-5 mb-2" style={{fontFamily: "ComicSans", fontWeight: 'bold'}}><i>{this.props.title}</i></h1>
                            <p className="lead mb-5 text-white">{this.props.subTitleText}</p>
                        </div>
                        <div className="col-lg-4">
                            <img className={"rounded-circle"} src={logo} style={{height: "250px", backgroundColor: "white"}} alt={"Engineering Guru"}/>
                        </div>
                    </div>
                </div>
            </header>
            <div className="container" style={{justifyContent: 'center', display: 'flex'}}>
                <p>Get latest updates by joining our
                    <strong>
                        <a href="https://t.me/joinchat/LaoovEe8ekwoTQPziHLpbQ"
                           target="_blank" rel="noopener noreferrer"> Telegram Group </a>
                    </strong>
                     and following our
                    <strong>
                        <a href="https://www.facebook.com/engineeringguru"
                           target="_blank" rel="noopener noreferrer"> Facebook Page </a> /
                        <a href="https://www.instagram.com/engineering__guru_"
                           target="_blank" rel="noopener noreferrer"> Instagram Page </a>
                    </strong>
                </p>
            </div>
            </div>
        );
    }
}

Header.propTypes = {};

export default Header;
